module.exports = __webpack_public_path__ + "img/carousel2.1d66fdcc.jpg";